import { backendApi } from '@app/services'

import { CurrenciesData } from './types'

export const fetchCurrencies = async (lang: string) => {
  const { data } = await backendApi.get<CurrenciesData>(`/currencies/${lang}`)
  return data
}
